import React from 'react';
import { NotificationPreferences } from '../../../../../../../../__generated__/loma';
import { LayoutTree } from '../../../../DynamicLayout';
import { useTranslations } from '../../../../../../hooks/useTranslations';
import { Channels } from '../../../types';
import OptInTemplate, { OptInChannelProps } from '../OptInTemplate';
import LineLogin from './LineLogin';
import LineLogo from '../../common/LineLogo';

interface LineOptInProps {
  featureName?: string;
  layout?: LayoutTree.FeatureLayout;
  channel: Channels;
  notificationPreferencesState?: NotificationPreferences;
}

const LineOptIn = ({
  featureName,
  layout,
  channel,
  notificationPreferencesState,
}: LineOptInProps) => {
  const { notificationCenterLineOptinMessage } = useTranslations();

  // TODO: Log an error?
  if (!notificationPreferencesState?.lineLoginUrl) return null;

  const lineOptInChannelProps: OptInChannelProps = {
    optInChannelInput: (
      <LineLogin
        layout={layout}
        url={notificationPreferencesState?.lineLoginUrl}
        featureName={featureName}
      />
    ),
    optInIcon: <LineLogo />,
    optInMessageText: notificationCenterLineOptinMessage || '',
    landscapeColWidths: [7, 5],
  };

  return (
    <OptInTemplate
      featureName={featureName}
      layout={layout}
      channel={channel}
      optInChannelProps={lineOptInChannelProps}
    />
  );
};

export default LineOptIn;
